import { Steps } from 'antd';

interface RegistrationStepsProps {
  current: number;
}

export default function RegistrationSteps({ current }: RegistrationStepsProps) {
  return (
    <Steps current={current} style={{ marginBottom: '20px' }}>
      <Steps.Step title="Create your account" />
      <Steps.Step title="Create your organisation" />
      <Steps.Step title="Set up billing" />
    </Steps>
  );
}
